import $ from "jquery";
import "@claviska/jquery-minicolors";
import {initWebComponent} from "@/helpers/web-component-helper";
import {setMeasureStyleValue, updateMeasureLayerStyle} from "@/helpers/tools/tools-measure-helper";
import {getActiveLayers} from "@/helpers/ol/ol-layer-helper";

export class LayerInfoToolsTemplateComponent extends HTMLElement {
    constructor(){
        super();

        let options = ''
        getActiveLayers().map(layer => {
            if(layer && layer.Type === 'WMS') {
                options += `<option value="${layer.ID}">${layer.DisplayName}</option>`
            }
        })

        const template = document.createElement('template');
        template.innerHTML = `
            <div class="row">
                <div class="col-md-12 d-none" id="divDrawFigure">
                    <div class="form-group">
                        <select size="1" class="form-control pt-0" id="slcDrawSnapLayer">
                            <option value="">Snap op laag</option>
                            ${options}
                        </select>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label class="form-label w-100">Vulling</label>
                            <div class="form-group w-100">
                              <input id="iptToolsFillColor" data-name="fill" type="text" class="form-control mini-colors" value="#3085b5" data-opacity="0.5">
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                        <label class="form-label">Omlijning</label>
                          <input id="iptToolsStrokeColor"  type="text" data-name="stroke" class="form-control mini-colors" value="#3085b5" data-opacity="1.0">
                        </div>
                        <div class="form-group col-md-6">
                          <div class="input-group">
                            <label class="form-label w-100">Breedte</label>
                            <input id="iptToolsStrokeWidth"  type="text" class="form-control" data-name="strokeWidth" value="4">
                          </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-none" id="divDrawText">
                    <div class="row">
                        <div class="col-12">
                                 <div class="form-row">
                            <div class="form-group col-md-6">
                                <label class="form-label">Kleur</label>
                                  <input type="text" data-name="fontColor" class="form-control mini-colors" value="#858380" data-opacity="1.0">
                                </div>
                                <div class="form-group col-md-6">
                                  <div class="input-group">
                                    <label class="form-label w-100">Grootte</label>
                                    <input type="text" class="form-control" data-name="fontSize" value="45">
                                  </div>
                                </div>
                                </div>
                          </div>
                        <div class="col-12">
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                <label class="form-label">Lettertype</label>
                                <select data-name="fontFamily" class="form-control">
                                    <option value="Arial" selected="selected">Arial</option>
                                    <option value="'Courier New'">Courier New</option>
                                    <option value="'Open Sans'">Open Sans</option>
                                    <option value="Verdana">Verdana</option>
                                </select>
                                </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        initWebComponent(this, template)

        $('.mini-colors').minicolors({
            opacity: true,
            change: function(element, opacity){

                switch ($(this).data('name')) {
                    case 'stroke':
                        setMeasureStyleValue('strokeColor', element)
                        setMeasureStyleValue('strokeOpacity', opacity)
                        break;
                    case 'fill':
                        setMeasureStyleValue('fillColor', element)
                        setMeasureStyleValue('fillOpacity', opacity)
                        break;
                    case 'labelOutlineColor':
                        setMeasureStyleValue('labelOutlineColor', element)
                        setMeasureStyleValue('labelOutlineOpacity', opacity)
                        break;
                    case 'fontColor':
                        setMeasureStyleValue('fontColor', element)
                        setMeasureStyleValue('fontOpacity', opacity)
                        break;
                }

                updateMeasureLayerStyle()
            }
        });

        this.addEventListener('change', (element) => {
            const name = element.target.dataset.name
            setMeasureStyleValue(name, element.target.value)
            updateMeasureLayerStyle()
        })
    }
}
